import type { RouteAccess } from 'src/routes/routeAccess';

/**
 * Marketplace app IDs for the Client Home app across environments (prod + staging).
 * Client Home is treated specially in a few surfaces (hidden from CRM tabs, pinned
 * above CRM in the Studio sidebar), so the IDs are shared from here.
 */
export const CLIENT_HOME_APP_IDS = [
  'a6e3a6f3-2f2a-4c79-b77c-9508da6e80dc',
  '89825056-6c20-43db-903b-6ffbe8b7bb23',
];

/**
 * Registry mapping internal and marketplace app IDs to their required routeAccess checks.
 * Apps listed here will be hidden from the sidebar if the corresponding
 * routeAccess check returns false.
 */
export const APP_REQUIRED_ROUTE_ACCESS: Record<string, keyof RouteAccess> = {
  // Billing integrations use allowPaymentsPage routeAccess check
  'c14f8c76-0004-4624-9754-cef11e263fe9': 'allowPaymentsPage', // Xero
  '9a90624e-5998-48ae-a7c4-917f473fedcc': 'allowPaymentsPage', // QuickBooks
  payments: 'allowPaymentsPage', // Payments
};

export const hasAppRouteAccess = (appId: string, routeAccess: RouteAccess) => {
  const routeAccessKey = APP_REQUIRED_ROUTE_ACCESS[appId];
  if (routeAccessKey) {
    const hasAccess = routeAccess[routeAccessKey];
    if (hasAccess === false) {
      return false;
    }
  }
  return true;
};
